/**
 * Copyright (C) Siemens AG 1996-2026 ALL RIGHTS RESERVED.
 *
 * Data Transfer Object for the external access request payload sent to the
 * user management service when a public passport viewer requests access.
 */

/**
 * Enum representing the available roles a requester can apply for.
 * Maps to the role identifiers expected by the user management service.
 */
export enum AccessRole {
  COMMISSION = 'COMMISSION',
  /** Notified bodies. */
  NOTIFIED_BODIES = 'NOTIFIED_BODIES',
  /** Market surveillance authorities. */
  MARKET_SURVEILLANCE_AUTHORITIES = 'MARKET_SURVEILLANCE_AUTHORITIES',
  /** Battery repair, repurposing and remanufacturing operators. */
  PERSON_INTEREST_REPAIR = 'PERSON_INTEREST_REPAIR',
  /** Recyclers and battery treatment operators. */
  PERSON_INTEREST_RECYCLER = 'PERSON_INTEREST_RECYCLER',
  /** Natural or legal person who legally purchased the battery (or a third party on their behalf). */
  PERSON_INTEREST_NATURAL = 'PERSON_INTEREST_NATURAL',
  /** Authorized treatment facilities and WEEE treatment facilities. */
  PERSON_INTEREST_TREATMENT_FACILITY = 'PERSON_INTEREST_TREATMENT_FACILITY',
}

/** All external roles; the single place the webapp derives its external role lists from. */
export const EXTERNAL_ROLES: string[] = Object.values(AccessRole);

export interface AccessRequestDto {
  firstName: string;
  lastName: string;
  email: string;
  organization: string;
  purposeOfAccess: string;
  roles: AccessRole[];
  passportId: string;
}
